<aslib-title Text="Carga de dados" SubText=" " Icon="fa fas fa-table"></aslib-title>
<router-outlet></router-outlet>
<div class="card-block">

  <div class="row">

      <div class="col-md-5">

        <div class="form-group">
          <label for="nomeArquivo">Nome do Arquivo: *</label>
            <input type="text" [(ngModel)]="nomeArquivo" name="nomeArquivo" readonly="true" class="form-control" style="display: inline-block;width: 70%;"
            placeholder='Selecione o arquivo...' />          
        </div>

      </div>

      <div class="col-md-2 text-left">
        <label class="btn btn-primary">
          Carregar Dados <input type="file" (change)="localizar($event, grid)" class="form-control" name="file" hidden>
        </label>
      </div>

      <div class="col-md-4 text-right">
        <button class="btn btn-primary" [disabled]="desabilitarRemover" (click)="remover(grid)">Limpar Registro(s) Inválido(s)</button>
      </div>

      <div class="col-md-1 text-left">
        <button class="btn btn-primary" [disabled]="desabilitarSalvar" (click)="salvar(grid)">Salvar</button>
      </div>

  </div>
    <!-- Div para apresentação do detalhe da liquidação. -->
    <ng-template #detalheLiq>
      <gpa-detalhe-carga-dados [liquidacao]="itemSelecionado"></gpa-detalhe-carga-dados>
    </ng-template>

  <aslib-grid #grid id="grid" name="grid" headerTitle="Dados para pagamento" [(dataset)]="lista"
    indexColumnVisible="true" limit="10">
    <aslib-grid-column [property]="'numeroProcessoSEI'" header="Número do Processo SEI" class="text-right" [width]="250"
      [sortable]="false" [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.numeroProcessoSEI | processoSei}}</span>
      </ng-template></aslib-grid-column>
    <aslib-grid-column [property]="'codigoCredor'" header="Código do Credor" class="text-right" [width]="200"
      [sortable]="false" [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.codigoCredor | credor}}</span>
      </ng-template>
    </aslib-grid-column>
      <aslib-grid-column [property]="'codigoSubElemento'" header="Código do Subelemento" class="text-right" [width]="200"
      [sortable]="false" [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.codigoSubElemento | subelemento}}</span>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'valorPagamentoBruto'" header="Valor Bruto" class="text-right" [width]="175" [sortable]="true"
      [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.valorPagamentoBruto | currency:'BRL'}}</span>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'historicoPagamento'" header="Histórico" class="text-left" [sortable]="false"
      [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <div *ngIf="item && (item.historicoPagamento?.length > 45)"><span>{{item.historicoPagamento |
            slice:0:45}}...</span></div>
        <div *ngIf="item && (item.historicoPagamento?.length <= 45)"><span>{{item.historicoPagamento}}</span></div>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'validado'" header="Validado" class="text-center" [width]="80" [sortable]="false"
      [resizable]="false">
      <ng-template #AslibGridCell let-item="item">
        <em *ngIf="item && item.statusValidacao === 0" class="fa fa-ban fa-lg" style="color:dimgray"
          title="Sem Validação"></em>
        <em *ngIf="item && item.statusValidacao === 1" class="fa fa-close fa-lg" style="color:red"
          title="Não Validado"></em>
        <em *ngIf="item && item.statusValidacao === 2" class="fa fa-check fa-lg" style="color:green"
          title="Validado"></em>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'active'" [header]="'Ações'" [width]="160" [sortable]="false" [resizable]="false"
      class="text-center">
      <ng-template #AslibGridHeader let-item="item"><span>Ações</span></ng-template>
      <ng-template #AslibGridCell let-item="item">
        <button type="button" class="btn btn-sm btn-primary" title="Exibir Histórico"
          ascas-data="Exibir detalhamento do histórico" (click)="detalharHistorico(item)">
          <aslib-icon type="1" icon="fa fa-fw fa-commenting-o"></aslib-icon>
        </button>
        <button type="button" class="btn btn-sm btn-primary" title="Exibir Dados Pagamento"
          ascas-data="Exibir detalhamento do pagamento" (click)="exibirDetalhes(detalheLiq, item)">
          <aslib-icon type="1" icon="fa fa-fw fa-money"></aslib-icon>
        </button>
        <button type="button" class="btn btn-sm btn-primary" title="Exibir Validação"
          [disabled]="item.statusValidacao !== 1" ascas-data="Exibir mensagem de validação"
          (click)="exibirValidacao(item)">
          <aslib-icon type="1" icon="fa fa-question-circle-o"></aslib-icon>
        </button>
      </ng-template>
    </aslib-grid-column>
  </aslib-grid>
</div>


// WEBPACK FOOTER //
// ./src/app/pagamento/carga-dados/carga-dados.component.html